// libs
import * as React from 'react'

// interfaces / constants
import { ILinkPreview } from 'src/interfaces/post_ingredients'
import {
  DisplaySettings,
  POST_DISPLAY_MODE_DETAIL,
  PostDisplayMode,
  Purpose
} from 'src/interfaces/posts'

// components
import LinkPreview from 'src/components/link_preview/link_preview'

type LinkPreviewSettings = { show: boolean };

const _settings: DisplaySettings<LinkPreviewSettings> = {
  admin: {
    basic_ingredient: { show: true }
  },
  banner: {
    basic_ingredient: { show: false }
  },
  compact: {
    basic_ingredient: { show: false }
  },
  detail: {
    basic_ingredient: { show: true }
  },
  preview: {
    basic_ingredient: { show: true }
  }
}

export interface IPropsData extends ILinkPreview {
  onRemove?: () => void;
  showRemoveIcon?: boolean;
}

export type IProps = {
  data: IPropsData;
  displayMode: PostDisplayMode;
  postDetailsURL?: string;
  purpose: Purpose;
};

const IngredientLinkPreview: React.FC<IProps> = ({
  data: {
    author = '',
    description = '',
    displayUrl = '',
    imageUrl,
    onRemove,
    showRemoveIcon = false,
    title,
    url = ''
  },
  displayMode,
  postDetailsURL = '',
  purpose
}) => {
  const settings = _settings[displayMode][purpose]

  if (!settings?.show) {
    return null
  }

  const isDetailsPage = displayMode === POST_DISPLAY_MODE_DETAIL

  return (
    <LinkPreview
      author={author}
      description={description || ''}
      displayUrl={displayUrl || url}
      imageUrl={imageUrl}
      large={isDetailsPage}
      onRemove={onRemove}
      showRemoveIcon={showRemoveIcon}
      target={isDetailsPage ? '_blank' : '_self'}
      title={title}
      url={isDetailsPage ? url : postDetailsURL}
    />
  )
}
export default IngredientLinkPreview
